import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "adminHome" */ "../views/LoginView.vue"),
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // },
  // {
  //   path: "/admin",
  //   redirect: "/admin/company", // /admin 경로로 접근하면 /admin/company로 리디렉션
  // },
  {
    path: "/company",
    name: "company",
    component: () =>
      import(/* webpackChunkName: "adminHome" */ "../views/AdminCompany.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/company/register",
    name: "companyRegister",
    component: () =>
      import(/* webpackChunkName: "adminHome" */ "../views/AdminCompanyRegister.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/company/detail",
    name: "companyDetail",
    component: () =>
      import(/* webpackChunkName: "adminHome" */ "../views/CompanyDetail.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/project",
    name: "project",
    component: () =>
      import(/* webpackChunkName: "adminHome" */ "../views/AdminProject.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/device",
    name: "device",
    component: () =>
      import(/* webpackChunkName: "adminHome" */ "../views/AdminDevice.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/license",
    name: "license",
    component: () =>
      import(/* webpackChunkName: "adminHome" */ "../views/AdminLicense.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/contract",
    name: "contract",
    component: () =>
      import(/* webpackChunkName: "adminHome" */ "../views/AdminContract.vue"),
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
